import _ from "lodash";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { URL } from "../../../../constant";
import { useLearningHistory } from "../../../../hooks";
import XbtnTitleHeader from "../../../common/header/XbtnTitleHeader";

const DiagnosisGuide1 = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { onLearningExitBtn } = useLearningHistory();

  const goNextPage = useCallback(() => {
    history.push(`${URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE2}`);
  });

  const goBackPage = useCallback(() => {
    onLearningExitBtn();
  });

  return (
    <div className="layout-def layout-lc">
      <XbtnTitleHeader title={t("LC_02_01.msg001")} onClose={goBackPage}/>
      <div className="container">
        <div className="inner">
          <div className="centermiddleBox">
            <div className="centermiddleBox-row">
              <div className={`dsc_cont1 ${getlanClass()}`}>
                <div className="aic-intro">
                  <div className="aic-intro-item">
                    <h2 className={`tit ${getlanClass()}`}>
                      {t("LC_02_01.msg003")}
                    </h2>
                  </div>

                  <div className="aic-intro-item">
                    <div className="imgBox">
                      <img
                        src={`${process.env.PUBLIC_URL}/static/images/common/diagnostic/img_main_01.png`}
                        alt=""
                      />
                    </div>
                  </div>

                  <div className="aic-intro-item">
                    <p
                      className="txt-normal txt-gray"
                      dangerouslySetInnerHTML={{ __html: t("LC_02_01.msg004") }}
                    />
                  </div>
                </div>

                {/* en */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-inner">
          <button className="btn btn-blue" onClick={goNextPage}>
            {t("LC_02_01.msg005")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiagnosisGuide1;

const getlanClass = () => {
  const { i18n } = useTranslation();
  return _.isEqual(i18n.language === "ko") ? "ko" : "en";
};
